import { render } from "./OpenCartModal.vue?vue&type=template&id=beabc51c"
import script from "./OpenCartModal.vue?vue&type=script&lang=js"
export * from "./OpenCartModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__